import styled, { css } from "styled-components";
import {
  NOTICE,
  NOTICE_LIGHTEST,
  TEXT_PRIMARY,
  WHITE
} from "@streeteasy/design-system/colors";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import TextAction from "@streeteasy/design-system/text-action";
import { Caps } from "@streeteasy/design-system/typography";

export const TextActionBase = styled(TextAction).attrs({
  element: actionElements.a
})``;

const resetStyles = css`
  background: 0;
  border: 0;
  box-sizing: border-box;
  display: inline;
  line-height: unset;
  margin: 0;
  padding: 0;
  text-decoration: none;

  * {
    box-sizing: border-box;
  }
`;

const withColor = ({ color }) => css`
  color: ${color};
  fill: ${color};
`;

const withActiveFocusHoverStyles = css`
  &:active,
  &:focus,
  &:hover {
    background-color: ${NOTICE_LIGHTEST};
    color: ${NOTICE};
    cursor: pointer;
    fill: ${NOTICE};
  }
`;

const withOutline = ({ color }) => {
  if (color === WHITE) {
    return css`
      &:focus {
        outline: 1px solid ${WHITE};
        outline-offset: 2px;
      }
    `;
  }

  return css`
    &:focus {
      outline: 1px solid ${TEXT_PRIMARY};
      outline-offset: 2px;
    }
  `;
};

const withUnderline = ({ underlined }) =>
  underlined &&
  css`
    &:not(svg):not(img) {
      text-decoration: underline;
      text-decoration-thickness: 1px;
      text-underline-offset: 3px;
    }
  `;

const withLinkStyles = css`
  ${resetStyles}
  ${withActiveFocusHoverStyles};
  ${withColor};
  ${withOutline};
  ${withUnderline};
`;

export const CapsLink = styled(Caps).attrs({
  as: "a"
})`
  ${withLinkStyles};
`;
